module.exports = __webpack_public_path__ + "img/heroBackground.94bf68e.webp";